// extracted by mini-css-extract-plugin
export default {"sectionFiveWrapper":"SectionFive_sectionFiveWrapper__3ZRd2"};